var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckEmailICon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5198 6.01364C11.8041 5.6726 12.3106 5.62688 12.6517 5.9111C12.9927 6.19529 13.0393 6.70187 12.7552 7.04293L8.79034 11.7998C8.22672 12.4761 7.19975 12.509 6.59405 11.8701L4.22101 9.36715C3.91557 9.04494 3.92906 8.53587 4.25128 8.23043C4.57339 7.92533 5.08163 7.9389 5.38702 8.26071L7.65265 10.6513L11.5198 6.01364Z",
    fill: "#00CE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.333 6.18891C15.333 4.8596 14.5101 3.66951 13.2666 3.19965L9.59961 1.81391C8.87175 1.539 8.06866 1.53893 7.34082 1.81391L3.67383 3.19965C2.43049 3.66959 1.60748 4.8597 1.60742 6.18891V10.9067C1.60742 11.9282 2.09625 12.8881 2.92188 13.4897L6.58789 16.1616C7.70958 16.9789 9.23085 16.9789 10.3525 16.1616L14.0195 13.4897C14.8449 12.8881 15.333 11.9281 15.333 10.9067V6.18891ZM16.9414 10.9067C16.9414 12.4421 16.2068 13.8853 14.9658 14.7895L11.2998 17.4614C9.61394 18.6898 7.32752 18.6896 5.6416 17.4614L1.97461 14.7895C0.733703 13.8853 0 12.4421 0 10.9067V6.18891C5.67751e-05 4.1909 1.23645 2.40101 3.10547 1.69477L6.77246 0.310002C7.86655 -0.103355 9.07387 -0.103313 10.168 0.310002L13.835 1.69477C15.7041 2.40095 16.9413 4.19082 16.9414 6.18891V10.9067Z",
    fill: "#00CE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckEmailICon);
export default __webpack_public_path__ + "static/media/checkEmailICon.b241356e0805c05792be8814e4273755.svg";
export { ForwardRef as ReactComponent };